import axios, { AxiosError } from 'axios'
import { redirect } from 'react-router-dom'

const baseUrl = process.env.REACT_APP_API_BASE_URL

const getAccessToken = () => {
  return localStorage.getItem('accessToken')
}

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`
  }
})

export const updateAccessToken = (token: string) => {
  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`
}

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const status = error.response?.status

    if (status === 403) {
      localStorage.clear()
      return redirect('/auth')
    }
    throw error
  }
)

export default axiosInstance
